function SliderCore() {

}

SliderCore.roundSlider = function(element, start, updateCallback) {
    if ($(element).hasClass('init')) { 
        return;
    }

    var _flag = false;
    $(element).addClass('init');

    $(element).roundSlider({
        sliderType: "min-range",
        handleShape: "round",
        width: 9,
        radius: 80,
        handleSize: "+8",
        value: start,
        startAngle: 90,

        update: function (args) {
            updateCallback(args);
        }
    });
}

SliderCore.rangeSlider = function(element, start, labels, slideCallback, min = 1, max = 100) {
    if ($(element).hasClass('init')) { 
        return;
    }

    var _flag = false;

    $(element).slider({
        value: start,
        min: min, 
        max: max,
        slide: function(event, ui) {
            if (!_flag) {
                _flag = true;
                return;
            }

            var value = ui.value;
            slideCallback(value);
        }  
    })
    .slider("float", {
        prefix: "",
        suffix: ""
    }).slider("pips", {
        labels: labels
    });
}